import { render, staticRenderFns } from "./adBetter.vue?vue&type=template&id=52452640&scoped=true"
import script from "./adBetter.vue?vue&type=script&lang=js"
export * from "./adBetter.vue?vue&type=script&lang=js"
import style0 from "./adBetter.vue?vue&type=style&index=0&id=52452640&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52452640",
  null
  
)

export default component.exports